/**
 * Tab styling on dashboard's sidebar
 */
import React, { Component } from 'react'
import styled from 'styled-components'

const Container = styled.div`
  width: 100%;
  height: calc(100% - 55px);
  padding: 20px 20px 20px 20px;

  overflow-x: hidden;
  overflow-y: scroll;

  ::-webkit-scrollbar {
      width: 12px;
  }
  ::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.1);
      border-radius: 10px;
      background-color: white;
  }
  ::-webkit-scrollbar-thumb {
      border-radius: 15px;
      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.20);
  }
`
const Content = styled.div`
  position: relative;
  _left: 5px;
  display: flex;
  flex-wrap: wrap;
`

class DashboardTab extends Component {
  render () {
    return (
      <Container>
        <Content>
          {this.props.children}
        </Content>
      </Container>
    )
  }
}

export default DashboardTab



// WEBPACK FOOTER //
// ./src/components/dashboard/DashboardTab.js